import { VaroCategories } from 'shared/analytics/types/categories';
import {
  ComponentAnalyticsProps,
  ListItemComponentAnalytics,
} from 'shared/analytics/types/componentEvents';
import { VaroListItemNames } from 'shared/analytics/types/listItemNames';
import { VaroSubCategories } from 'shared/analytics/types/subCategories';

type MyVaroListItemTaxonomy = ComponentAnalyticsProps & {
  itemName: ListItemComponentAnalytics['itemName'];
};

// Keyed by the stable tile id the server sends, never by display copy.
const MY_VARO_LIST_ITEM_TAXONOMY: Record<string, MyVaroListItemTaxonomy> = {
  MY_VARO_PROFILE_SECTION_PERSONAL_DETAILS_LIST_ITEM: {
    itemName: VaroListItemNames.ACCOUNT_MANAGEMENT.PERSONAL_DETAILS,
    category: VaroCategories.ACCOUNT_MANAGEMENT,
  },
  MY_VARO_PROFILE_SECTION_NOTIFICATION_SETTINGS_LIST_ITEM: {
    itemName: VaroListItemNames.SETTINGS.NOTIFICATION_SETTINGS,
    category: VaroCategories.SETTINGS,
    subCategory: VaroSubCategories.SETTINGS.NOTIFICATIONS,
  },
  MY_VARO_PROFILE_SECTION_MANAGE_ACCOUNTS_LIST_ITEM: {
    itemName: VaroListItemNames.ACCOUNT_MANAGEMENT.MANAGE_ACCOUNTS,
    category: VaroCategories.ACCOUNT_MANAGEMENT,
  },
  MY_VARO_PROFILE_SECTION_STATEMENTS_LIST_ITEM: {
    itemName: VaroListItemNames.ACCOUNT_MANAGEMENT.STATEMENTS_AND_DOCUMENTS,
    category: VaroCategories.ACCOUNT_MANAGEMENT,
  },
  MY_VARO_PROFILE_SECTION_FRIENDS_LIST_ITEM: {
    itemName: VaroListItemNames.REFERRAL.INVITE_FRIENDS,
    category: VaroCategories.REFERRAL,
  },
  MY_VARO_HELP_SECTION_HELP_AND_SUPPORT_LIST_ITEM: {
    itemName: VaroListItemNames.SERVICING.HELP_AND_SUPPORT,
    category: VaroCategories.SERVICING,
  },
  MY_VARO_HELP_SECTION_DISPUTES_LIST_ITEM: {
    itemName: VaroListItemNames.SERVICING.DISPUTES,
    category: VaroCategories.SERVICING,
    subCategory: VaroSubCategories.SERVICING.DISPUTE,
  },
  MY_VARO_HELP_SECTION_LEGAL_AGREEMENTS_LIST_ITEM: {
    itemName: VaroListItemNames.ACCOUNT_MANAGEMENT.LEGAL_AGREEMENTS,
    category: VaroCategories.ACCOUNT_MANAGEMENT,
  },
};

/**
 * `itemPosition` is the zero-based index of the tile within its own section,
 * not within the page.
 */
export const getMyVaroListItemAnalytics = (
  tileId: string,
  itemPosition: number,
): ListItemComponentAnalytics | undefined => {
  const taxonomy = MY_VARO_LIST_ITEM_TAXONOMY[tileId];

  if (!taxonomy) {
    return undefined;
  }

  return { ...taxonomy, itemPosition };
};
